import React from "react";

function NotFound() {
  return <h1>404! This page doesn't exist</h1>;
}

export default NotFound;
